module.exports = __webpack_public_path__ + "img/queding.e324afc2.svg";